import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WorkorderAfterSales3ModalComponent } from '../workorder-after-sales3-modal/workorder-after-sales3-modal.component';

@Component({
  selector: 'app-workorder-after-sales2-modal',
  templateUrl: './workorder-after-sales2-modal.component.html',
  styleUrls: ['./workorder-after-sales2-modal.component.scss'],
})
export class WorkorderAfterSales2ModalComponent {
  constructor(
    private dialogRef: MatDialogRef<WorkorderAfterSales2ModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  close() {
    this.dialogRef.close();
  }

  solveProblem(data: any) {
    if (data.solution) {
      window.open(data.solution);
      localStorage.setItem('bus_seat_id', this.data.bus_seat_id);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/user/profile/seats']);
      });
      return;
    }
    this.dialog
      .open(WorkorderAfterSales3ModalComponent, {
        data: Object.assign({}, data, {
          bus_id: this.data.bus_id,
          bus_seat_id: this.data.bus_seat_id,
          platform_id: this.data.platform_id,
          bus_account_id: this.data.bus_account_id,
          order_id: '',
          platform_name: this.data.platform_name,
        }),
      })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.close();
        }
      });
  }
}
